/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "PayWithSquareEntryMethod": {
            "values": {
              "SCANNED": 1,
              "KEYED": 2,
              "NAME": 3,
              "FRANKLIN": 4,
              "WEB_STORE_WEB_FORM": 5,
              "INVOICE_WEB_FORM": 6,
              "REGISTER_SWIPED": 7,
              "REGISTER_MANUALLY_KEYED": 8,
              "WALLET_PICKUP": 9,
              "SUBSCRIPTION_DASHBOARD": 10,
              "WEB_PICKUP": 11,
              "EXTERNAL_API": 12,
              "EXTERNAL_API_ON_FILE": 22,
              "STARBUCKS_SWIPED": 13,
              "STARBUCKS_MANUALLY_KEYED": 14,
              "APPOINTMENTS": 15,
              "REGISTER_EMV_CONTACT": 16,
              "REGISTER_CONTACTLESS": 17,
              "INVOICE_ON_FILE": 18,
              "ONLINE_STORE": 19,
              "REGISTER_CARD_ON_FILE": 20,
              "TERMINAL_KEYED": 23,
              "CAPITAL_ON_FILE": 24,
              "EGIFT_PURCHASE_KEYED": 25,
              "TERMINAL_CARD_ON_FILE": 26,
              "WEB_STORE_CARD_ON_FILE": 27,
              "TERMINAL_SWIPED": 28,
              "REGISTER_HARDWARE_SWIPED": 29,
              "REGISTER_HARDWARE_EMV_CONTACT": 30,
              "REGISTER_HARDWARE_CONTACTLESS": 31,
              "REGISTER_HARDWARE_MANUALLY_KEYED": 32,
              "REGISTER_HARDWARE_CARD_ON_FILE": 33,
              "APPOINTMENTS_KEYED": 34,
              "EXTERNAL_API_QR_CODE": 38,
              "EXTERNAL_API_REDIRECT": 39,
              "EXTERNAL_API_SMS": 40,
              "REGISTER_QR_CODE": 41,
              "REGISTER_SMS": 42,
              "REGISTER_HARDWARE_QR_CODE": 43,
              "REGISTER_HARDWARE_SMS": 44,
              "TERMINAL_EMV_CONTACT": 45,
              "TERMINAL_CONTACTLESS": 46,
              "BUYER_SUBSCRIPTIONS_ON_FILE": 47,
              "BUYER_SUBSCRIPTIONS_WEB_FORM": 48,
              "WEB_STORE_QR_CODE": 49,
              "WEB_STORE_REDIRECT": 50,
              "INVOICE_REDIRECT": 51,
              "TERMINAL_QR_CODE": 52,
              "TERMINAL_REDIRECT": 53,
              "INVOICE_QR_CODE": 54,
              "FNB_KIOSK_SWIPED": 55,
              "FNB_KIOSK_MANUALLY_KEYED": 56,
              "FNB_KIOSK_EMV_CONTACT": 57,
              "FNB_KIOSK_CONTACTLESS": 58,
              "BILLPAY_ON_FILE": 59,
              "FNB_KIOSK_QR_CODE": 60,
              "CHECKING_ON_FILE": 61
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.PayWithSquareEntryMethod) {
  $root.addJSON(jsonData);
}

/**
 * This is the enum that determines the "entry method" of the transactions incoming to Square.
 * It is primarily used for:
 * - Calculating Fees for different product (in Ledger).
 * - Analytics segmenting payments to different products.
 *
 * ****************************************************************************
 * ****************************************************************************
 *
 * If you update this you also must coordinate with reconciliation, settlements,
 * analytics and reporting, and other teams.
 *
 * If you add a entry method that may be considered E-Commerce, you must inform
 * drew@ or li@ so that we can send the transaction under the correct transaction division
 * number to Paymentech (eero-common.yaml).
 *
 * Contact payments-team@ and data@ for changes.
 *
 * ****************************************************************************
 * ****************************************************************************
 *
 * SOURCE PayWithSquareEntryMethod @ squareup/common/entry_method.proto at 27:1
 */
export const PayWithSquareEntryMethod = $root.lookupEnum('squareup.common.PayWithSquareEntryMethod').values;